module.exports = __webpack_public_path__ + "2fbb894d80f3630d7c11a36479c90af7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/mummy.png
// module id = +7BM
// module chunks = 0